import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withNamespaces } from 'react-i18next';

import SweetAlert from 'react-bootstrap-sweetalert';
import {
  Button,
  Card,
  CardBody,
  Col,
  Row,
  Badge,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
} from 'reactstrap';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { entry_strategy_status } from '../../constants/entry_strategy_fields';
import { deleteEntryStrategy, toggleEntryStrategy, createEntryStrategy } from '../../store/actions';

class EntryStrategyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      deleteModal: false,
      strategyToDelete: null,
      createModal: false,
      newStrategyName: '',
    };
  }

  handleDelete() {
    const { strategyToDelete, user } = this.state;

    this.props.deleteEntryStrategy({
      token: user.token,
      id: strategyToDelete.id,
      history: this.props.history,
    });

    this.setState({ deleteModal: false, strategyToDelete: null });
  }

  handleToggle(strategy) {
    const { user } = this.state;
    const nextState = strategy.active !== '1';

    this.props.toggleEntryStrategy({
      token: user.token,
      id: strategy.id,
      active: nextState,
      history: this.props.history,
    });
  }

  handleCreate() {
    const { newStrategyName, user } = this.state;

    if (!newStrategyName.trim()) return;

    this.props.createEntryStrategy(
      {
        token: user.token,
        name: newStrategyName.trim(),
      },
      this.props.history,
    );

    this.setState({ createModal: false, newStrategyName: '' });
  }

  render() {
    const { t, entryStrategies } = this.props;
    const { deleteModal, createModal, newStrategyName } = this.state;

    return (
      <>
        <Row>
          <Col>
            <Card>
              <CardBody>
                {/* Cabecera de la sección */}
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <Button
                    color="secondary"
                    className="btn btn-primary waves-effect waves-light usersButtons"
                    onClick={() => this.setState({ createModal: true })}
                  >
                    <i className="mdi mdi-plus mr-1"></i> {t('AddStrategy')}
                  </Button>
                </div>

                {/* Tabla de estrategias */}
                {!entryStrategies || entryStrategies.length === 0 ? (
                  <div className="text-center text-muted my-4">
                    <strong>{t('NoEntryStrategiesYet')}</strong>
                  </div>
                ) : (
                  <div className="table-responsive">
                    <Table className="table table-centered table-nowrap mb-0">
                      <Thead>
                        <Tr>
                          <Th>
                            <i className="bx bx-user-pin mr-2 my-auto"></i>
                            {t('ID')}
                          </Th>
                          <Th>
                            <i className="bx bx-user-pin mr-2 my-auto"></i>
                            {t('EntryStrategyName')}
                          </Th>
                          <Th style={{ width: '150px' }} className="text-center">
                            <i className="bx bx-check-circle mr-2 my-auto"></i>
                            {t('Status')}
                          </Th>
                          <Th style={{ width: '220px' }} className="text-center">
                            <i className="bx bx-brush mr-2 my-auto"></i>
                            {t('Actions')}
                          </Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {entryStrategies.map((es, key) => {
                          return (
                            <Tr key={key}>
                              <Td className="align-middle font-weight-bold">{es.id}</Td>
                              <Td className="align-middle font-weight-bold">{es.name}</Td>
                              <Td className="align-middle text-center">
                                <Badge
                                  color={entry_strategy_status[es.active].color}
                                  className={'badge-soft-' + entry_strategy_status[es.active].color + ' font-size-13'}
                                  pill
                                >
                                  {entry_strategy_status[es.active].name}
                                </Badge>
                              </Td>
                              <Td className="align-middle text-center">
                                {/* Detalle/Editar */}
                                <Button
                                  className="btn btn-primary waves-effect waves-light buttonStatus txtField mr-1"
                                  color="primary"
                                  title={t('Detail')}
                                  onClick={() =>
                                    this.props.history.push({
                                      pathname: `/entry-strategy/${es.id}`,
                                      state: es,
                                    })
                                  }
                                >
                                  <i className="mdi mdi-pencil font-size-14 align-middle"></i>
                                </Button>

                                {/* ➔ BOTÓN DE TOGGLE */}
                                <Button
                                  className="btn waves-effect waves-light buttonStatus txtField mr-1"
                                  color={es.active === '1' ? 'secondary' : 'success'}
                                  title={es.active === '1' ? t('Deactivate') : t('Activate')}
                                  onClick={() => this.handleToggle(es)}
                                >
                                  <i className="mdi mdi-power font-size-14" style={{ verticalAlign: 'middle' }}></i>
                                </Button>

                                {/* Eliminar */}
                                <Button
                                  className="btn btn-danger waves-effect waves-light buttonStatus txtField"
                                  title={t('Delete')}
                                  onClick={() =>
                                    this.setState({
                                      deleteModal: true,
                                      strategyToDelete: es,
                                    })
                                  }
                                >
                                  <i className="far fa-trash-alt font-size-14 align-middle"></i>
                                </Button>
                              </Td>
                            </Tr>
                          );
                        })}
                      </Tbody>
                    </Table>
                  </div>
                )}

                {/* MODAL ELIMINAR */}
                {deleteModal && (
                  <SweetAlert
                    showCancel
                    title={t('AreYouSure')}
                    cancelBtnBsStyle="danger"
                    confirmBtnBsStyle="success"
                    confirmBtnText={t('ok')}
                    cancelBtnText={t('Cancel')}
                    onConfirm={() => this.handleDelete()}
                    onCancel={() => this.setState({ deleteModal: false, strategyToDelete: null })}
                  >
                    {t('ThisActionWillDeleteTheEntryStrategy')}
                  </SweetAlert>
                )}

                {/* MODAL CREAR */}
                <Modal isOpen={createModal} toggle={() => this.setState({ createModal: false })}>
                  <ModalHeader toggle={() => this.setState({ createModal: false })}>
                    {t('AddNewEntryStrategy')}
                  </ModalHeader>
                  <ModalBody>
                    <FormGroup>
                      <Label for="strategyNameInput">{t('EntryStrategyName')}</Label>
                      <Input
                        type="text"
                        id="strategyNameInput"
                        placeholder="Ej: Full product"
                        value={newStrategyName}
                        onChange={(e) => this.setState({ newStrategyName: e.target.value })}
                      />
                    </FormGroup>
                  </ModalBody>
                  <ModalFooter>
                    <Button color="danger" onClick={() => this.setState({ createModal: false })}>
                      {t('Cancel')}
                    </Button>
                    <Button color="success" disabled={!newStrategyName.trim()} onClick={() => this.handleCreate()}>
                      {t('Add')}
                    </Button>
                  </ModalFooter>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { errorDeleteEntryStrategy, loadingDeleteEntryStrategy } = state.deleteEntryStrategy || {};
  const { errorCreateEntryStrategy, loadingCreateEntryStrategy } = state.createEntryStrategy || {};
  const { errorToggleEntryStrategy, loadingToggleEntryStrategy } = state.toggleEntryStrategy || {};

  return {
    errorDeleteEntryStrategy,
    loadingDeleteEntryStrategy,
    errorCreateEntryStrategy,
    loadingCreateEntryStrategy,
    errorToggleEntryStrategy,
    loadingToggleEntryStrategy,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    deleteEntryStrategy,
    toggleEntryStrategy,
    createEntryStrategy,
  })(withNamespaces()(EntryStrategyList)),
);
